import api from '@/api';

export default class CityParametersService {
  retrieveAuthorization(clientName) {
    // Mock data.
    // return new Promise(resolve => {
    //   setTimeout(() => {
    //     resolve({
    //       tenantId: '132456798'
    //     })
    //   }, 50)
    // })

    return api.get(`auth/token?tenantCode=${clientName}`)
      .then((response) => new Promise((resolve) => { resolve(response.data); }))
      .catch((error) => new Promise((resolve, reject) => { reject(error); }));
  }
}
